import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { Message, Dimmer, Loader, Button, Grid, Divider, Segment } from 'semantic-ui-react';
import { withRouter } from 'react-router';
import { Route, Switch } from 'react-router-dom';
import _ from 'lodash'; 
import { 
    getBankOptions, 
    getClinicLocatorListBySysAdmin, 
    updateClinicFilterOptions, 
    updateClinicSelection, 
    updateClinicSearchValue, 
    downloadClinicListBySysAdmin,
    getSystemAdminClients,
    getAuditUserAction ,
    submitSystemAdminUserBankAccount,
    submitSystemAdminUpdateDefaultCompany,
    submitSystemAdminUpdateUser,
    getSystemAdminUserDetail
} from "../../actions";
import BankUtility from "../../utils/bankUtility/BankUtility"

import UserFormNavigation from '../../component/sysadmin/user/user_form/user_form_navigation';
import UserFormBasicInformation from '../../component/sysadmin/user/user_form/user_form_basic_information';
import UserFormLoginInformation from '../../component/sysadmin/user/user_form/user_form_login_information';
import UserFormBankDetail from '../../component/sysadmin/user/user_form/user_form_bank_detail';
import UserFormCompanies from '../../component/sysadmin/user/user_form/user_form_companies';
import UserFormPanelClinics from '../../component/sysadmin/user/user_form/user_form_panel_clinics';
import UserFormStudent from '../../component/sysadmin/user/user_form/user_form_student';
import UserAuditTable from "../../component/sysadmin/user/user_form/user_audit_table";

class SysadminUserDependentsPage extends Component {
    state = {
        userDetail: this.props.userDetail,
        successSubmit: null,
        loadingCompany: false,
        successMsg: '',
        errorMsg: '',
        uuid: "",

        currentPage: 1,
        perPage: 10,
        totalPage: 1,
        totalData: 1,
        isLoading:false,
          
        isLoadingClinic: true,
        downloadClinicLoading: false,
        downloadClinicError: false,
        pinCode: null,
        pinCodeLoading: false,
    }
    bankUtility = new BankUtility();

    componentDidMount() {
        if (this.props.user) {
            this._onRefresh()
        }
    }

    componentDidUpdate(prevProps) {
        const { search } = prevProps.location 
        console.log('prevProps.location ', prevProps.location )
        if(search !== this.props.location.search){
            this._onRefresh()
        }

        const { filterByCompany } = prevProps.filterOptions;
        if (filterByCompany !== this.props.filterOptions.filterByCompany) {
            this.setState({ isLoadingClinic: true }, () => {
                if (this.props.filterOptions.filterByCompany){
                    this.props.updateClinicSearchValue({search: '', results:[]})
                    this.props.getClinicLocatorListBySysAdmin(this.props.user.accessToken, this.props.filterOptions.filterByCompany, this.state.userDetail.nric, (result, error) => {
                        if(result || error) {
                            this.props.updateClinicSelection({mode:1, selectedClinicObjectKey: null});
                            this.setState({ isLoadingClinic: false })
                        }
                    })
                }
            })
        }
    
    }

     

    _onRefresh(){
        const { accessToken } = this.props.user;
        if (accessToken) {
            this.setState({ isLoading: true }, () => {

                this.props.updateClinicFilterOptions({filterByType: null, filterByArea: null, filterByCompany: null});
                this.props.updateClinicSearchValue({search: '', results:[]})    

                // Get user ID
                const queryString = new URLSearchParams(this.props.history.location.search);
                const userId = queryString.get("idUser");

                //   Get the user Audit
                this.getUsers(userId) 

                // Get user
                this.props.getSystemAdminUserDetail({ accessToken, userId }, (result, error) => {
                    if (result && result.data) {
                        this.setState({ 
                            isLoading: false, 
                            userDetail: result.data.user,
                            uuid:userId 
                        }, () => {
                            this.props.updateClinicFilterOptions({filterByType: null, filterByArea: null, filterByCompany: result.data.user.companyId});
                        })
                    }
                })

                // Get bank list
                if (this.props.appConfig.bankList && !this.props.appConfig.bankList.blV2) {
                    this.props.getBankOptions();
                }
            })
        }
    }

    clickBasicInformation() {
        this.setState(
            { ...this.state, successSubmit: undefined, errorMsg: '', successMsg: '' },
            this.props.history.push({ pathname: "/systemadmin/user/update", search: this.props.history.location.search })
        );
    }

    clickLoginInformation() {
        this.setState(
            { ...this.state, successSubmit: undefined, errorMsg: '', successMsg: '' },
            this.props.history.push({ pathname: "/systemadmin/user/update/loginInformation", search: this.props.history.location.search })
        );
    }

    clickBankDetail() {
        this.setState(
            { ...this.state, successSubmit: undefined, errorMsg: '', successMsg: '' },
            this.props.history.push({ pathname: "/systemadmin/user/update/bankDetails", search: this.props.history.location.search })
        );
    }

    clickProposedBankDetail() {
        this.setState(
            { ...this.state, successSubmit: undefined, errorMsg: '', successMsg: '' },
            this.props.history.push({ pathname: "/systemadmin/user/update/proposedBankDetails", search: this.props.history.location.search })
        );
    }

    clickCompanies() {
        this.setState(
            { ...this.state, successSubmit: undefined, errorMsg: '', successMsg: '' },
            this.props.history.push({ pathname: "/systemadmin/user/update/companies", search: this.props.history.location.search })
        );
    }

    clickFormStudent() {
        this.setState(
            { ...this.state, successSubmit: undefined, errorMsg: '', successMsg: '' },
            this.props.history.push({ pathname: "/systemadmin/user/update/student", search: this.props.history.location.search })
        );
    }

    clickPanelClinics() {
        this.setState(
            { ...this.state, successSubmit: undefined, errorMsg: '', successMsg: '' },
            this.props.history.push({ pathname: "/systemadmin/user/update/panelClinics", search: this.props.history.location.search })
        );
    }

    clickUserAudit() {
        this.setState(
          { ...this.state, successSubmit: undefined, errorMsg: "", successMsg: "" },
          this.props.history.push({
            pathname: "/systemadmin/user/update/audit",
            search: this.props.history.location.search
          })
        );
      }

    renderSubmitResult() {
        if (this.state.successSubmit === true) {
            return (
                <Message positive>
                    <Message.Header>{this.state.successMsg || "User Updated Successfully!"}</Message.Header>
                </Message>
            );
        }
        if (this.state.successSubmit === false) {
            return (
                <Message negative>
                    <Message.Header>We're sorry - there was an issue</Message.Header>
                    <p>{this.state.errorMsg}</p>
                </Message>
            );
        }
    }

    onSubmitBasicInformation = (values, actions) => {

        // Prepare data to send 
        let dataToSend = {
            accessToken: this.props.user.accessToken,
            userId: this.state.userDetail.uuid,
            data: {
                companyId: values.companyCode,
                nric: values.nric,
                name: values.name,
                birthdate: moment(values.birthdate).valueOf(),
                gender: values.gender,
                email: values.email || `temp_${values.nric}@groupcareincome.com.sg`.toLowerCase(),
                contactNo: values.contactNo,
                contactNoCountryCode: values.contactNoCountryCode,
            }
        };

        // Prepare default family data to send
        if(Array.isArray(values.companies) && values.companies.length > 0){
            let defaultCompany = values.companies[0]
            dataToSend.data.family = defaultCompany.familyDetail.map(fam => ({
                nric: fam.nric,
                name: fam.name,
                birthdate: fam.birthdate ? moment(fam.birthdate).valueOf() : null,
                relationship: fam.relationship,
                planNo: fam.planNo,
                effectiveStartDate: fam.effectiveStartDate ? moment(fam.effectiveStartDate).valueOf() : null,
                effectiveEndDate: fam.effectiveEndDate ? moment(fam.effectiveEndDate).valueOf() : null,
            }))
        }

        // edit user
        this.props.submitSystemAdminUpdateUser(
            dataToSend,
            (result, error) => {
                if (result) {
                    this.setState({ ...this.state, successSubmit: true, successMsg: '', errorMsg: '', userDetail: result.result });
                }
                if (error) {
                    this.setState({ ...this.state, successSubmit: false, successMsg: '', errorMsg: error.errorMessage });
                }
            }
        )
    }

    onSubmitLoginInformation(values, actions) {

        // Prepare data to send 
        let dataToSend = {
            accessToken: this.props.user.accessToken,
            userId: this.state.userDetail.uuid,
            data: {
                email: values.email || `temp_${values.nric}@groupcareincome.com.sg`.toLowerCase(),
                status: values.status,
                onboardingEmailSent: values.onboardingEmailSent
            }
        };

        // edit user
        this.props.submitSystemAdminUpdateUser(
            dataToSend,
            (result, error) => {
                if (result) {
                    this.setState({ ...this.state, successSubmit: true, successMsg: '', errorMsg: '', userDetail: result.result });
                }
                if (error) {
                    this.setState({ ...this.state, successSubmit: false, successMsg: '', errorMsg: error.errorMessage });
                }
            }
        )
    }

    setDefaultCompany(companyId) {
        this.setState({ loadingCompany: true })
        // Prepare data to send 
        let dataToSend = {
            accessToken: this.props.user.accessToken,
            userId: this.state.userDetail.uuid,
            data: {
                changeDefaultcompany: companyId
            }
        };
        console.log("check is it insiee")
        // edit user
        this.props.submitSystemAdminUpdateDefaultCompany(
            dataToSend,
            (result, error) => {
                if (result) {
                    this.setState({ ...this.state, loadingCompany: false, successSubmit: true, successMsg: '', errorMsg: '', userDetail: result.result });
                }
                if (error) {
                    this.setState({ ...this.state, loadingCompany: false, successSubmit: false, successMsg: '', errorMsg: error.errorMessage });
                }
            }
        )
    }


    onSubmitBank = (values, actions) => {

        // Validate proposed bank data 
        if( !this.bankUtility.isBankCodeExist(this.props.appConfig.bankList.blV2, values.proposedBankDetail.bankNo) ) {
            return this.setState({ successSubmit: false, errorMsg: 'Invalid Bank Code', successMsg: '' });
        }
        if( !this.bankUtility.isBranchCodeExist(this.props.appConfig.bankList.blV2, values.proposedBankDetail.bankNo, values.proposedBankDetail.branchNo) ) {
            return this.setState({ successSubmit: false, errorMsg: 'Invalid Branch Code', successMsg: '' });
        }

        this.props.submitSystemAdminUpdateUser({
            accessToken: this.props.user.accessToken,
            userId: this.state.userDetail.uuid,
            data: { proposedBankDetail: values.proposedBankDetail }
        },
            (result, error) => {
                if (result) {
                    this.setState({ ...this.state, successSubmit: true, successMsg: '', errorMsg: '', userDetail: result.result });
                }
                if (error) {
                    this.setState({ ...this.state, successSubmit: false, successMsg: '', errorMsg: error.errorMessage });
                }
            }
        )
    }

    onSubmitStudentData = (values, actions) => {

        this.props.submitSystemAdminUpdateUser({
            accessToken: this.props.user.accessToken,
            userId: this.state.userDetail.uuid,
            data: {
                studentFullBankAccountNo: values.studentFullBankAccountNo,
                studentEmail: values.studentEmail,
                studentTel: values.studentTel,
                studentCareerCode: values.studentCareerCode,
                studentMaritalStatus: values.studentMaritalStatus,
                studentID: values.studentID,
                studentNationality: values.studentNationality,
                singaporeCitizenshipstatus: values.singaporeCitizenshipstatus,
                nsMenIndicator: values.nsMenIndicator,
            }
        },
            (result, error) => {
                if (result) {
                    this.setState({ ...this.state, successSubmit: true, successMsg: '', errorMsg: '', userDetail: result.result });
                }
                if (error) {
                    this.setState({ ...this.state, successSubmit: false, successMsg: '', errorMsg: error.errorMessage });
                }
            }
        )
    }

    removeCompany(companyIndex, values) {
        this.setState({ loadingCompany: true })
        let companyFiltered = values.companies
        companyFiltered.splice(companyIndex, 1);
        console.log("check default", companyFiltered)
        // Prepare data to send 
        let dataToSend = {
            accessToken: this.props.user.accessToken,
            userId: this.state.userDetail.uuid,
            isRemovedCompanyId: true,
            data: {
                companies: companyFiltered.map(comp => (
                    {
                        companyId: comp.companyId,
                        effectiveStartDate: comp.effectiveStartDate ? moment(comp.effectiveStartDate).valueOf() : null,
                        effectiveEndDate: comp.effectiveEndDate ? moment(comp.effectiveEndDate).valueOf() : null,
                        memberType: comp.memberType,
                        designation: comp.designation,
                        planNo: comp.planNo,
                        staffId: comp.staffId,
                        costCenter: comp.costCenter,
                        costCenterName: comp.costCenterName,
                        family: comp.familyDetail.map(fam => ({
                            nric: fam.nric,
                            name: fam.name,
                            birthdate: fam.birthdate ? moment(fam.birthdate).valueOf() : null,
                            relationship: fam.relationship,
                            planNo: fam.planNo,
                            effectiveStartDate: fam.effectiveStartDate ? moment(fam.effectiveStartDate).valueOf() : null,
                            effectiveEndDate: fam.effectiveEndDate ? moment(fam.effectiveEndDate).valueOf() : null,
                        }))
                    }
                ))
            }
        };

        // edit user
        this.props.submitSystemAdminUpdateUser(
            dataToSend,
            (result, error) => {
                if (result) {
                    this.setState({ ...this.state, loadingCompany: false, successSubmit: true, successMsg: '', errorMsg: '', userDetail: result.result });
                }
                if (error) {
                    this.setState({ ...this.state, loadingCompany: false, successSubmit: false, successMsg: '', errorMsg: error.errorMessage });
                }
            }
        )
    }

    onSubmitCompanies = (values, actions) => {
        
        // Prepare data to send 
        let dataToSend = {
            accessToken: this.props.user.accessToken,
            userId: this.state.userDetail.uuid,
            data: {
                companies: values.companies.map(comp => (
                    {
                        companyId: comp.companyId,
                        effectiveStartDate: comp.effectiveStartDate ? moment(comp.effectiveStartDate).valueOf() : null,
                        effectiveEndDate: comp.effectiveEndDate ? moment(comp.effectiveEndDate).valueOf() : null,
                        memberType: comp.memberType,
                        designation: comp.designation,
                        planNo: comp.planNo,
                        staffId: comp.staffId,
                        costCenter: comp.costCenter,
                        costCenterName: comp.costCenterName,
                        family: comp.familyDetail.map(fam => ({
                            nric: fam.nric,
                            name: fam.name,
                            birthdate: fam.birthdate ? moment(fam.birthdate).valueOf() : null,
                            relationship: fam.relationship,
                            planNo: fam.planNo,
                            effectiveStartDate: fam.effectiveStartDate ? moment(fam.effectiveStartDate).valueOf() : null,
                            effectiveEndDate: fam.effectiveEndDate ? moment(fam.effectiveEndDate).valueOf() : null,
                        }))
                    }
                )),
            }
        };

        // edit user
        this.props.submitSystemAdminUpdateUser(
            dataToSend,
            (result, error) => {
                if (result) {
                    this.setState({ ...this.state, successSubmit: true, successMsg: '', errorMsg: '', userDetail: result.result });
                }
                if (error) {
                    this.setState({ ...this.state, successSubmit: false, successMsg: '', errorMsg: error.errorMessage });
                }
            }
        )
    }

    showFormStudent() {

        if (Array.isArray(this.state.userDetail.companies)) {
            let compFound = this.state.userDetail.companies.find(comp => comp.companyDetail.policyNo === "2100653158" || comp.companyDetail.policyNo === "2100653765");
            return compFound ? true : false;
        }
        return false;
    }

    getUsers = (uuid) => {
        const { accessToken } = this.props.user;  
        this.setState({isLoading:true}) 
        this.props.getAuditUserAction({
            id:uuid,
            searchPage: this.state.currentPage,
            searchMax: this.state.perPage,
            accessToken
          }).then(()=>{
            if(this.props.userAudit && this.props.userAudit.pagination){
                this.setState({
                    totalPage: this.props.userAudit.pagination.totalPage,
                    totalData: this.props.userAudit.pagination.totalData,
                    isLoading: false,
                })
            }
          })
    }
    
      setParams = () => { 
        let params = `idUser=${this.state.uuid}?page=${this.state.currentPage}&v=${this.state.perPage}`
        this.props.history.push({
            search: params
        })
    }
    
      goToPreviousPage = () => {
        if (this.state.currentPage > 1) {
          this.setState({ currentPage: this.state.currentPage - 1 }, () => {
            this.setParams();
            this.getUsers(this.state.uuid);
          });
        }
      };
    
      goToNextPage = () => { 
        this.setState({ currentPage: this.state.currentPage + 1 }, () => {
            this.setParams();
            this.getUsers(this.state.uuid);
          }); 
      };
    
      setPage = num => {
        this.setState({ currentPage: num }, () => {
          this.setParams();
          this.getUsers(this.state.uuid);
        });
      };
    
      setPerPage = num => {
        this.setState({ perPage: num, currentPage: 1 }, () => {
          this.setParams();
          this.getUsers(this.state.uuid);
        });
      };

    onResendPinCode = (email) => {
        const { accessToken } = this.props.user;
        const { uuid } = this.state.userDetail;
        this.setState({ pinCodeLoading: true, pinCode: null });
        this.props.submitSystemAdminUpdateUser(
            { accessToken, userId: uuid, data: { email, generatePin: true } },
            (result, error) => {
                if (result) {
                    console.log("result from submit admin update users ", result)
                    this.setState({ pinCodeLoading: false, pinCode: result }, () => {
                        this._onRefresh();
                    });
                }
                if (error) {
                    this.setState({ pinCodeLoading: false });
                }
            }
        );
    }

      _handleDownloadClinicListBySysAdmin(accessToken, companyId, type, nric){
        this.setState({ 
            downloadClinicLoading: true,
            downloadClinicError: false
        })

        downloadClinicListBySysAdmin(accessToken, companyId, type, nric, (result, error) => {
            this.setState({ downloadClinicLoading: false })
            if(error){
                this.setState({
                    downloadClinicError: true
                })
            }
        })
    }

    render() { 
        const admin = this.props.user;
        let queryString = new URLSearchParams(this.props.history.location.search);
        const clientId = queryString.get("idCompany");
        const client = _.find(this.props.clients, (client) => client._id === clientId);
        const isLoading = (this.props.appConfig.bankList.blV2) ? false : true;

        return (

            <Dimmer.Dimmable>
                <Dimmer active={isLoading} inverted>
                    <Loader />
                </Dimmer>

                {/* Display user not found */}
                {!isLoading && this.state.userDetail === null &&
                    <> User Not Found </>
                }

                {/* Display user */}
                {!isLoading && this.state.userDetail !== null &&
                    <React.Fragment>
                        <br />
                        <Grid>
                            <Grid.Column width={4}>
                                <UserFormNavigation
                                    clickBasicInformation={this.clickBasicInformation.bind(this)}
                                    clickLoginInformation={this.clickLoginInformation.bind(this)}
                                    clickBankDetail={this.clickBankDetail.bind(this)}
                                    clickCompanies={this.clickCompanies.bind(this)}
                                    clickFormStudent={this.clickFormStudent.bind(this)}
                                    clickPanelClinics={this.clickPanelClinics.bind(this)}
                                    clickUserAudit={this.clickUserAudit.bind(this)}
                                    showStudentForm={this.showFormStudent()}
                                />
                            </Grid.Column>
                            <Grid.Column width={12}>
                                <Switch>
                                    <Route exact path="/systemadmin/user/update" component={() =>
                                        <UserFormBasicInformation
                                            user={this.state.userDetail}
                                            company={client}
                                            admin={admin}
                                            onSubmit={this.onSubmitBasicInformation.bind(this)}
                                            renderSubmitResult={this.renderSubmitResult.bind(this)}
                                        />
                                    } />

                                    <Route path="/systemadmin/user/update/loginInformation" component={() =>
                                        <UserFormLoginInformation
                                            user={this.state.userDetail}
                                            admin={admin}
                                            onSubmit={this.onSubmitLoginInformation.bind(this)}
                                            renderSubmitResult={this.renderSubmitResult.bind(this)}
                                            showDetail={true}
                                            onResendPinCode={this.onResendPinCode}
                                            pinCode={this.state.pinCode}
                                            pinCodeLoading={this.state.pinCodeLoading}
                                        />} />

                                    <Route path="/systemadmin/user/update/bankDetails" component={() =>
                                        <UserFormBankDetail
                                            user={this.state.userDetail}
                                            admin={admin}
                                            bankList={this.props.appConfig.bankList.blV2}
                                            onSubmit={this.onSubmitBank.bind(this)}
                                            renderSubmitResult={this.renderSubmitResult.bind(this)}
                                        />} />

                                    <Route exact path="/systemadmin/user/update/student" component={() =>
                                        <UserFormStudent
                                            user={this.state.userDetail}
                                            admin={admin}
                                            onSubmit={this.onSubmitStudentData.bind(this)}
                                            clients={this.props.clients}
                                            renderSubmitResult={this.renderSubmitResult.bind(this)}
                                        />
                                    } />

                                    <Route exact path="/systemadmin/user/update/companies" component={() =>
                                        <UserFormCompanies
                                            user={this.state.userDetail}
                                            admin={admin}
                                            loadingCompany={this.state.loadingCompany}
                                            removeCompanySingle = {this.removeCompany.bind(this)}
                                            onChangeDefaultCompany={this.setDefaultCompany.bind(this)}
                                            onSubmit={this.onSubmitCompanies.bind(this)}
                                            clients={this.props.clients}
                                            renderSubmitResult={this.renderSubmitResult.bind(this)}
                                        />
                                    } />

                                    <Route path="/systemadmin/user/update/panelClinics" component={() =>
                                        <UserFormPanelClinics
                                            users={this.state.userDetail}
                                            mode={this.state.mode}
                                            clinics={this.props.clinics}
                                            typeList={this.props.typeList}
                                            zoneList={this.props.zoneList}
                                            areaList={this.props.areaList}
                                            filterOptions={this.props.filterOptions}
                                            updateClinicFilterOptions={this.props.updateClinicFilterOptions}
                                            getClinicLocatorListBySysAdmin={this.props.getClinicLocatorListBySysAdmin}
                                            user={this.props.user}
                                            isLoadingClinic={this.state.isLoadingClinic}
                                            selection={this.props.selection}
                                            updateClinicSelection={this.props.updateClinicSelection}
                                            updateClinicSearchValue={this.props.updateClinicSearchValue}
                                            searchValue={this.props.searchValue}
                                            downloadClinicListBySysAdmin={this._handleDownloadClinicListBySysAdmin.bind(this)}
                                            downloadClinicLoading={this.state.downloadClinicLoading}
                                            downloadClinicError={this.state.downloadClinicError}
                                        />} 
                                    />

                                    <Route
                                            exact
                                            path="/systemadmin/user/update/audit"
                                            component={() => (
                                            <UserAuditTable
                                                isLoading={this.state.isLoading}
                                                result={this.props.userAudit.result}
                                                admin={admin}
                                                // onSubmit={this.onSubmitCompanies.bind(this)}
                                                // clients={this.props.clients}
                                                // renderSubmitResult={this.renderSubmitResult.bind(this)}
                                                currentPage={this.state.currentPage}
                                                perPage={this.state.perPage}
                                                totalPage={this.state.totalPage}
                                                totalData={this.state.totalData}
                                                setPage={num => this.setPage(num)}
                                                setPerPage={num => this.setPerPage(num)}
                                                goToPreviousPage={() => this.goToPreviousPage()}
                                                goToNextPage={() => this.goToNextPage()}
                                                paginationHandler={this.paginationHandler}
                                            />
                                            )}
                                        />

                                </Switch>
                            </Grid.Column>
                        </Grid>
                    </React.Fragment>
                }
            </Dimmer.Dimmable>
        )
    }
}

SysadminUserDependentsPage.defaultProps = {
    userDetail: {
        companyName: '',
        companyCode: '',
        name: '',
        nric: '',
        birthdate: moment().format('YYYY-MM-DD'),
        gender: '',
        status: '',
        designation: '',
        contactNo: '',
        contactNoCountryCode: '',
        mainTerms: '',
        subTerm1: '',
        subTerm2: '',
        planNo: '',
        costCenter: '',
        effectiveStartDate: moment().format('YYYY-MM-DD'),
        effectiveEndDate: '',
        newNric: '',
        changeEffectiveDate: '',
        bankDetail: {
            bankName: '',
            bankNo: '',
            branchNo: '',
            accountNo: '',
        },
        email: '',
        costCenterName: '',
        loginRequired: 'Y',
        studentFullBankAccountNo: '',
        studentEmail: '',
        studentTel: '',
        studentCareerCode: '',
        studentMaritalStatus: '',
        studentID: '',
        studentNationality: '',
        singaporeCitizenshipstatus: '',
        nsMenIndicator: '',
        familyDetail: [],
        companies: [],
    },
    company: null,
    allowEditBank: false,
    showProposedBankUI: false,
    admin: {},
    onCreateUser: undefined
}

const mapStateToProps = (state) => {
    return {
        user: state.user.user,
        users: state.systemAdmin.users,
        userAudit: state.user.userAudit,
        clients: state.systemAdmin.clients,
        appConfig: state.appConfig,
        clinics: state.clinics.data,
        typeList: state.clinics.typeList,
        zoneList: state.clinics.zoneList,
        areaList: state.clinics.areaList,
        filterOptions: state.clinics.filterOptions,
        selection: state.clinics.selection,
        searchValue: state.clinics.search
    };
}


export default withRouter(connect(mapStateToProps, {
    getSystemAdminUserDetail,
    submitSystemAdminUpdateUser,
    submitSystemAdminUpdateDefaultCompany,
    submitSystemAdminUserBankAccount,
    getBankOptions,
    getClinicLocatorListBySysAdmin,
    updateClinicFilterOptions,
    updateClinicSelection,
    updateClinicSearchValue,
    getAuditUserAction,
    getSystemAdminClients
})(SysadminUserDependentsPage))
